import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { Box, Divider, Text } from '@chakra-ui/react'
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { GroupsElementT } from "shared/api/types/services";
import CutText from "shared/components/CutText";
import { PathsE } from "shared/routes";
import CopyButton from "shared/components/CopyButton";

export const useGetGetBreadcrumbs = () => {
  const { t } = useTranslation();
  return [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
  ];
}

// interface Params {
//   handleActivate(id: string): void
//   handleDeactivate(id: string): void
//   handleDelete(id: string): void,
//   serviceId: string
// }

export const useGetColumns = () => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<GroupsElementT>();

  return useMemo(
    () => [
      columnHelper.accessor('id', {
        header: t('services.table.id'),
        id: 'id',
        cell: ({ getValue }) => (
          <CutText fontWeight="700">
            {getValue()}
          </CutText>
        ),
        meta: {
          isSorting: false,
          styles: {
            sizes: {
              width: '90px',
              maxW: '90px',
            }
          }
        }
      }),
      columnHelper.accessor('name', {
        header: t('services.table.name'),
        id: 'name',
      }),
      columnHelper.accessor('note', {
        header: t('services.table.note'),
        id: 'note',
        cell: ({ getValue }) => (
          <Text dangerouslySetInnerHTML={{ __html: getValue() }} />
        ),
        meta: {
          styles: {
            sizes: {
              maxW: '200',
              width: '200',
            }
          }
        }
      }),
      // columnHelper.accessor('sheetLink', {
      //   header: t('services.table.sheetLink'),
      //   id: 'sheetLink',
      //   cell: ({ getValue }) => (
      //     <Box textAlign="center" alignItems="center" display="flex" gap={4}>
      //       <CutText fontWeight="700">{getValue()}</CutText>
      //       <CopyButton text={getValue()} />
      //       <Divider orientation='vertical' borderColor="blackAlpha.500" height="24px" w="1px" />
      //     </Box>
      //   ),
      //   meta: {
      //     isSorting: false,
      //     styles: {
      //       sizes: {
      //         width: '150px',
      //         maxW: '150px',
      //       }
      //     }
      //   }
      // }),
      columnHelper.accessor('link', {
        header: t('services.table.link'),
        id: 'apiId',
        cell: ({ getValue }) => (
          <Box textAlign="center" alignItems="center" display="flex" gap={4}>
            <CutText fontWeight="700">{getValue()}</CutText>
            <CopyButton text={getValue()} />
            <Divider orientation='vertical' borderColor="blackAlpha.500" height="24px" w="1px" />
          </Box>
        ),
        meta: {
          isSorting: false,
          styles: {
            sizes: {
              width: '200px',
              maxW: '200px',
            }
          }
        }
      }),
      columnHelper.accessor('id', {
        header: t('Echo Link'),
        id: 'Echo Link',
        cell: () => {
          const value = "https://t.me/+MMjs0mrwLYcwMTRi";
          return (
            <Box textAlign="center" alignItems="center" display="flex" gap={4}>
              <CutText fontWeight="700">{value}</CutText>
              <CopyButton text={value} />
              <Divider orientation='vertical' borderColor="blackAlpha.500" height="24px" w="1px" />
            </Box>
          );
        },
        meta: {
          isSorting: false,
          styles: {
            sizes: {
              width: '200px',
              maxW: '200px',
            }
          }
        }
      }),
      columnHelper.accessor('link', {
        header: t('Topics Link'),
        id: 'Topics Link',
        cell: () => {
          const value = "https://t.me/+2woVN3Kh85cxOWIy";
          return (
          <Box textAlign="center" alignItems="center" display="flex" gap={4}>
            <CutText fontWeight="700">{value}</CutText>
            <CopyButton text={value} />
          </Box>
        );
      },
        meta: {
          isSorting: false,
          styles: {
            sizes: {
              width: '200px',
              maxW: '200px',
            }
          }
        }
      }),

      // columnHelper.accessor('createdAt', {
      //   header: t('services.table.createdAt'),
      //   id: 'createdAt',
      //   cell: ({ getValue }) => formatDateToHuman(getValue(), false),
      //   meta: {
      //     isNumeric: true,
      //     styles: {
      //       sizes: {
      //         width: '120px'
      //       }
      //     }
      //   }
      // }),
      // columnHelper.accessor('updatedAt', {
      //   header: t('services.table.updatedAt'),
      //   id: 'updatedAt',
      //   cell: ({ getValue }) => formatDateToHuman(getValue(), false),
      //   meta: {
      //     isNumeric: true,
      //     styles: {
      //       sizes: {
      //         width: '120px'
      //       }
      //     }
      //   }
      // }),
      // columnHelper.accessor('id', {
      //   header: '',
      //   id: 'actions',
      //   cell: ({ row }) => (
      //     <MainItemMenu
      //       data={row.original as FixMeLater}
      //       viewLink={PathsE.SHOW_GROUP}
      //       editLink={PathsE.UPDATE_GROUP}
      //       pathsParams={{
      //         serviceId,
      //         groupId: row.original.id
      //       }}
      //       handleActivate={handleActivate}
      //       handleDeactivate={handleDeactivate}
      //       handleDelete={handleDelete}
      //     />
      //   ),
      //   meta: {
      //     styles: {
      //       sizes: {
      //         width: '44px'
      //       }
      //     }
      //   }
      // }),
    ] as ColumnDef<GroupsElementT>[],
    [t]
  );
};
